import { z } from 'zod';
import { isoDateSchema } from './common.js';
export const reportRangeQuerySchema = z.object({
    taxpayerProfileId: z.uuid().optional(),
    /** Reports are per currency; defaults to the taxpayer's default currency. */
    currencyCode: z.string().length(3).regex(/^[A-Z]{3}$/).optional(),
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
});
export const dashboardSchema = z.object({
    currencyCode: z.string(),
    mixedCurrencies: z.boolean(),
    kpis: z.object({
        invoicedThisMonth: z.string(),
        collectedThisMonth: z.string(),
        outstandingTotal: z.string(),
        overdueTotal: z.string(),
        overdueCount: z.number(),
        draftCount: z.number(),
        issuedThisMonthCount: z.number(),
    }),
    monthly: z.array(z.object({ month: z.string(), invoiced: z.string(), collected: z.string() })),
    recentInvoices: z.array(z.object({
        id: z.uuid(),
        invoiceNumber: z.string(),
        buyerName: z.string().nullable(),
        coreStatus: z.string(),
        payableAmount: z.string(),
        issueDate: z.string(),
        currencyCode: z.string(),
    })),
    attention: z.array(z.object({
        kind: z.enum(['overdue', 'draft', 'import_review', 'integration']),
        title: z.string(),
        detail: z.string(),
        link: z.string(),
    })),
});
export const salesReportSchema = z.object({
    from: z.string(),
    to: z.string(),
    currencyCode: z.string(),
    totals: z.object({
        invoiceCount: z.number(),
        taxExclusive: z.string(),
        tax: z.string(),
        total: z.string(),
        collected: z.string(),
        outstanding: z.string(),
    }),
    byMonth: z.array(z.object({ month: z.string(), invoiceCount: z.number(), taxExclusive: z.string(), tax: z.string(), total: z.string() })),
    byCustomer: z.array(z.object({ customerName: z.string(), invoiceCount: z.number(), total: z.string(), outstanding: z.string() })),
    byTaxCategory: z.array(z.object({ taxCategoryCode: z.string(), taxPercent: z.string(), taxableAmount: z.string(), taxAmount: z.string() })),
});
export const outstandingReportSchema = z.object({
    asOf: z.string(),
    currencyCode: z.string(),
    totals: z.object({ outstanding: z.string(), overdue: z.string(), invoiceCount: z.number() }),
    aging: z.array(z.object({ bucket: z.string(), invoiceCount: z.number(), amount: z.string() })),
    byCustomer: z.array(z.object({ customerName: z.string(), invoiceCount: z.number(), outstanding: z.string(), oldestDueDate: z.string().nullable() })),
    invoices: z.array(z.object({
        id: z.uuid(),
        invoiceNumber: z.string(),
        buyerName: z.string().nullable(),
        issueDate: z.string(),
        dueDate: z.string().nullable(),
        daysOverdue: z.number(),
        payableAmount: z.string(),
        paidAmount: z.string(),
        outstandingAmount: z.string(),
    })),
});
export const paymentsReportSchema = z.object({
    from: z.string(),
    to: z.string(),
    currencyCode: z.string(),
    total: z.string(),
    count: z.number(),
    byMethod: z.array(z.object({ method: z.string(), count: z.number(), amount: z.string() })),
    byDay: z.array(z.object({ date: z.string(), amount: z.string() })),
    payments: z.array(z.object({
        id: z.uuid(),
        invoiceId: z.uuid(),
        invoiceNumber: z.string(),
        buyerName: z.string().nullable(),
        paymentDate: z.string(),
        amount: z.string(),
        paymentMethod: z.string().nullable(),
        reference: z.string().nullable(),
    })),
});
export const EXPORT_DATASETS = ['invoices', 'payments', 'customers', 'products', 'outstanding'];
export const exportRequestSchema = z.object({
    dataset: z.enum(EXPORT_DATASETS),
    currencyCode: z.string().length(3).regex(/^[A-Z]{3}$/).optional(),
    format: z.enum(['csv', 'xlsx']).default('csv'),
    taxpayerProfileId: z.uuid().optional(),
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
});
//# sourceMappingURL=reports.js.map